import React, { useState } from 'react'
import { BlockPicker, SketchPicker } from 'react-color'

const SeleccionarColor = (props) => {

    const {
        abrirModal,
        setAbrirModal,
        id,
        fill,
        setNodos,
        nodos,
        isSelected,
    } = props;

    

    const [color, setColor] = useState(fill);

    const [colorFigura, setColorFigura] = useState(fill);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
        setAbrirModal(!abrirModal);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
        setAbrirModal(false);
    };

    const handleChange = (color) => {
        setColorFigura(color.rgb)
        setColor(color.rgb)
    };

    const cambiarColor = (color)=> {
        setColorFigura(color.rgb)
        setColor(color.rgb)
        setNodos(
            nodos.map((nodo)=>{
                if(id === nodo.id){
                    /* console.log(color) */
                    return {
                        ...nodo,
                        isDragging: false,
                        fill: color.hex
                    }
                }else{
                    /* console.log('no cumple') */
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }

    return (
        <div>
            { isSelected ? 
                <div style={ {
                    position: 'absolute',
                    zIndex: '2',
                    marginTop: '100px'
                }}>
                    <div 
                        style={{
                            position: 'fixed',
                            top: '0px',
                            right: '0px',
                            bottom: '0px',
                            left: '0px',
                        }}
                        onClick={handleClose}
                    />
                    {/* <SketchPicker 
                        color={ color } 
                        onChange={ cambiarColor } 
                    /> */}
                    <BlockPicker
                        color={ color } 
                        onChange={ cambiarColor }
                    />
                </div> 
            : null 
            }

        </div>
    )
}

export default SeleccionarColor;